export const SUMMER_CAMPAIGN_LEAD_CONTACT_STATUSES = [
  "NOT_CONTACTED",
  "CONTACTED",
  "NO_ANSWER",
  "CALLBACK_REQUESTED",
  "IN_CONVERSATION",
] as const;

export type SummerCampaignLeadContactStatus =
  (typeof SUMMER_CAMPAIGN_LEAD_CONTACT_STATUSES)[number];

const CONTACT_STATUS_LABELS: Record<SummerCampaignLeadContactStatus, string> = {
  NOT_CONTACTED: "לא נוצר קשר",
  CONTACTED: "נוצר קשר",
  NO_ANSWER: "אין מענה",
  CALLBACK_REQUESTED: "מבקש שיחזרו",
  IN_CONVERSATION: "בטיפול",
};

export function contactStatusLabel(status: string | null | undefined): string {
  if (!status) return CONTACT_STATUS_LABELS.NOT_CONTACTED;
  return (
    CONTACT_STATUS_LABELS[status as SummerCampaignLeadContactStatus] ?? status
  );
}

export function contactStatusFromVoicenterAnswer(isAnswer: number | undefined) {
  return isAnswer === 0 ? "NO_ANSWER" : "CONTACTED";
}
